import { LoginFunction } from 'components/providers/loginContext';
import { ENDPOINT_LOGPARAMETER } from 'constants/constants';
import { getAPI } from 'utils/commonService';

export type LogParameter = {
  logParameter: string;
};

// 指定したWFアプリの実行ジョブのログを取得する
export async function getLogParameter(
  id: string,
  ioFlg: string,
  loginContext: LoginFunction,
): Promise<LogParameter[]> {
  const params = { id, ioFlg };
  return (await getAPI(
    ENDPOINT_LOGPARAMETER,
    loginContext,
    params,
  )) as LogParameter[];
}
